"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var ButtonSection = function ButtonSection(_ref) {
  var isAgent = _ref.isAgent,
    isDraft = _ref.isDraft,
    setRefundAction = _ref.setRefundAction,
    goToDashboard = _ref.goToDashboard;
  var processBtnClasses = (0, _classnames.default)('refund-button-section__primary-btn');
  var saveBtnClasses = (0, _classnames.default)('refund-button-section__secondary-btn');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-around"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: 6,
    container: true,
    direction: "row",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: processBtnClasses,
    "aria-label": "Process Request",
    onClick: function onClick() {
      setRefundAction('process');
    },
    type: "submit",
    "data-test-id": "process-request"
  }, "Process Request")), isAgent && /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: 6,
    container: true,
    direction: "row",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: saveBtnClasses,
    "aria-label": "Save Request",
    type: "submit",
    onClick: function onClick() {
      setRefundAction('save');
    },
    "data-test-id": "save-request"
  }, "Save Request")), isDraft && /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: isAgent ? 12 : 6,
    container: true,
    direction: "row",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "refund-button-section__secondary-btn",
    "aria-label": "Delete Request",
    type: "submit",
    onClick: function onClick() {
      setRefundAction('delete');
    },
    "data-test-id": "delete-request"
  }, "Delete Request"))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "refund-button-section__tertiary-btn",
    "aria-label": "Close",
    onClick: goToDashboard,
    type: "button",
    "data-test-id": "close"
  }, "Close")));
};
ButtonSection.propTypes = {
  isAgent: _propTypes.bool.isRequired,
  isDraft: _propTypes.bool.isRequired,
  setRefundAction: _propTypes.func.isRequired,
  goToDashboard: _propTypes.func.isRequired
};
var _default = exports.default = ButtonSection;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/ButtonSection/styles.scss');